<template>
  <div class="field">
    <div class="is-flex">
      <label class="is-size-6 is-expanded">{{ label }}</label>
      <label
        class="required-label is-size-7"
        style="margin-top: 4px;"
      >{{ required ? 'required' : 'optonal' }}</label>
    </div>
    <div class="control has-icons-right">
      <input
        class="input"
        :type="type"
        :placeholder="placeholder"
        v-model="model"
        :class="{'is-danger':valid===false, 'is-success':valid===true}"
      />
      <span class="icon is-small is-right has-text-danger" v-show="valid===false">
        <font-awesome-icon icon="exclamation"></font-awesome-icon>
      </span>
      <span class="icon is-small is-right has-text-success" v-show="valid===true">
        <font-awesome-icon icon="check"></font-awesome-icon>
      </span>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: {
    label: {
      type: String,
      default: "Label"
    },
    type: {
      type: String,
      default: "text"
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      required: true
    },
    valid: {
      default: "unset"
    }
  },
  data() {
    return {
      model: ""
    };
  },
  watch: {
    value() {
      let component = this;
      if (component.type === "date" && moment(component.value).isValid()) {
        component.model = moment(component.value).format("YYYY-MM-DD");
      } else {
        component.model = component.value;
      }
    },
    model() {
      let component = this;
      component.$emit("input", component.model);
    }
  }
};
</script>